import React, { useState, useMemo } from 'react';
import './UniversityGazette.css';
import PageHeader from '../about/PageHeader';
import Navbar from '../components/navbar';
import Footer from '../components/Footer';

const GAZETTE_ARCHIVE = [
  {
    period: "First Half 2025",
    categories: {
      Regular: [
        {
          title: "Gazette Copy of  MASTER OF COMPUTER APPLICATIONS (SEM-II)(CHOICE BASED)(2 YEARS COURSE) EXAMINATION HELD IN MAY 2025 (FH-2025)",
          pdfUrl: "/pdf/Examination/COL715-7.pdf"
        },
        {
          title: "Gazette Copy of MASTER OF COMPUTER APPLICATIONS (SEM-I)(CHOICE BASED)(2 YEARS COURSE) EXAMINATION HELD IN MAY 2025 (FH-2025)",
          pdfUrl: "/pdf/Examination/COL715-4.pdf"
        },
        {
          title: "Gazette Copy of MASTER OF COMPUTER APPLICATIONS (SEM-III)(CHOICE BASED)(2 YEARS COURSE) EXAMINATION HELD IN JUNE 2025 (FH-2025)",
          pdfUrl: "/pdf/Examination/COL715-5.pdf"
        },
        {
          title: "Gazette Copy of MASTER OF COMPUTER APPLICATIONS (SEM.IV)(CHOICE BASED)(TWO YEARS) DEGREE EXAMINATION HELD IN JULY 2025 (F.H.2025)",
          pdfUrl: "/pdf/Examination/COLLB715.pdf"
        },
      ]
    }
  },
  {
    period: "Second Half 2024",
    categories: {
      Regular: [
        {
          title: "Gazette Copy of MASTER OF COMPUTER APPLICATIONS (SEM-III)(CHOICE BASED)(2 YEARS COURSE) EXAMINATION HELD IN JANUARY 2025 (SH-2024)",
          pdfUrl: "/pdf/Examination/COL715-2.pdf"
        },
        {
          title: "Gazette Copy of MASTER OF COMPUTER APPLICATIONS (SEM-III)(CHOICE BASED)(2 YEARS COURSE) EXAMINATION HELD IN DECEMBER 2024 (SH-2024)",
          pdfUrl: "/pdf/Examination/COL715-7.pdf"
        },
      ],
      KT: [
        "Gazette Copy of MASTER OF COMPUTER APPLICATIONS (SEM-II)(CHOICE BASED)(2 YEARS COURSE) EXAMINATION HELD IN DECEMBER 2024 (SH-2024)",
        "Gazette Copy of THE MASTER OF COMPUTER APPLICATIONS (SEM-II)(CHOICE BASED)(2 YEARS COURSE) EXAMINATION HELD IN DECEMBER 2024 (SH-2024)"
      ]
    }
  }
];
// SVG Icons
const IconSearch = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>;
const IconChevron = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg>;
const IconFile = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>;

const UniversityGazette = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activePeriod, setActivePeriod] = useState(GAZETTE_ARCHIVE[0].period);
  const [activeTab, setActiveTab] = useState("Regular");

  const currentPeriodData = useMemo(() =>
    GAZETTE_ARCHIVE.find(p => p.period === activePeriod), [activePeriod]
  );

  const availableTabs = useMemo(() =>
    Object.keys(currentPeriodData.categories), [currentPeriodData]
  );

  const results = useMemo(() => {
    const list = currentPeriodData.categories[activeTab] || currentPeriodData.categories[availableTabs[0]] || [];

    return list.filter(item => {
      // 1. Extract the title safely whether item is an object or a string
      const title = typeof item === 'object' ? item.title : item;

      // 2. Perform the search (added optional chaining ?. just in case)
      return title?.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }, [currentPeriodData, activeTab, searchTerm, availableTabs]);

  const handlePeriodChange = (period) => {
    setActivePeriod(period);
    const newPeriodData = GAZETTE_ARCHIVE.find(p => p.period === period);
    if (!newPeriodData.categories[activeTab]) {
      setActiveTab(Object.keys(newPeriodData.categories)[0]);
    }
  };

  const handleViewPdf = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      alert("PDF link not found for this entry.");
    }
  };

  // Logic to Trigger Browser Download
  const handleDownloadPdf = (url, fileName) => {
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      alert("File not available for download.");
    }
  };

  return (
    <>
      <Navbar />
      <PageHeader
        title="University Gazette"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "University Gazette" },
        ]}
      />
      <div className="ugsb-page-wrapper">
        <div className="ugsb-main-container">


          <div className="ugsb-layout-grid">
            <aside className="ugsb-sidebar">
              <ul className="ugsb-sidebar-list">
                {GAZETTE_ARCHIVE.map((item) => (
                  <li
                    key={item.period}
                    className={`ugsb-sidebar-item ${activePeriod === item.period ? 'active' : ''}`}
                    onClick={() => handlePeriodChange(item.period)}
                  >
                    {item.period} <IconChevron />
                  </li>
                ))}
              </ul>
            </aside>

            <main className="ugsb-content">
              <div className={`ugsb-card ${activeTab !== 'Regular' ? 'ugsb-card-accent' : ''}`}>
                <div className="ugsb-card-tabs">
                  <span className="ugsb-card-label">{activePeriod}</span>
  <div
    className="ugsb-tab-indicator"
    style={{
      transform: activeTab === "Regular"
        ? "translateX(0%)"
        : "translateX(100%)"
    }}
  />
                  {availableTabs.map(tab => (
                    <button
                      key={tab}
                      className={`ugsb-tab ${activeTab === tab ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                  
                </div>

                <div className="ugsb-card-body">
                  {results.length > 0 ? results.map((res, idx) => {
                    // Determine if we have a title and a URL
                    const title = typeof res === 'object' ? res.title : res;
                    const url = typeof res === 'object' ? res.pdfUrl : null;

                    return (
                      <div key={idx} className="ugsb-result-row">
                        <div className="ugsb-res-left">
                          <IconFile />
                          <div className="ugsb-res-info">
                            <p className="ugsb-res-title">
                              {title}
                              {(activeTab === 'KT' || activeTab === 'Special KT') && <span className="ugsb-badge-kt">KT</span>}
                            </p>
                          </div>
                        </div>
                        <div className="ugsb-btn-group">
                          <button
                            className="ugsb-btn-outline"
                            onClick={() => handleViewPdf(url)}
                            disabled={!url} // Disable if no URL provided
                          >
                            View
                          </button>
                          <button
                            className="ugsb-btn-solid"
                            onClick={() => handleDownloadPdf(url, title)}
                            disabled={!url} // Disable if no URL provided
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    );
                  }) : (
                    <p className="ugsb-empty-msg">No results found for your search/filter selection.</p>
                  )}
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UniversityGazette;